import {get, post, patch} from "../api"
import * as url from "../url"

const apiGetNotificationsList = data => {
  return get(url.API_NOTIFICATIONS, data.history)
}

const apiPostNotificationsNew = data => {
  return post(url.API_NOTIFICATIONS, data.history, data.values)
}

export {
  apiGetNotificationsList,
  apiPostNotificationsNew,
}
